import { IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import { useMemo } from 'react';

import { DeleteIcon } from '@/assets/icons';
import { StyledTooltip } from '@/helpers/styles';
import { theme } from '@/modules/common/theme';
import { OverflowTypography } from '@/modules/common/components/OverflowTypography';

import { useOrderProfileExcel } from '../hooks/useOrderProfileExcel';
import { useOrderProfileStore } from '../store/useOrderProfileStore';

const buttonStyle = {
  padding: 0,
  borderRadius: '2px',
  '&:hover': {
    color: theme.palette.primary.main,
  },
  '&:active:hover': {
    color: theme.palette.primary.main,
  },
};

export const OrderProfileFile = () => {
  const { orderProfile } = useOrderProfileStore.getState();
  const { removeOrderProfile } = useOrderProfileExcel();

  const filename = useMemo(() => orderProfile?.uploadedFileName, [orderProfile]);

  if (!filename) {
    return null;
  }
  return (
    <Stack direction='row' alignItems='center' gap={1} sx={{ width: '100%' }}>
      <OverflowTypography
        sx={{
          display: 'flex',
          fontSize: 12,
          mr: 'auto',
          marginY: '1rem',
        }}
      >
        {filename}
      </OverflowTypography>
      <StyledTooltip title='Delete custom flows'>
        <IconButton onClick={() => removeOrderProfile()} sx={buttonStyle}>
          <DeleteIcon />
        </IconButton>
      </StyledTooltip>
    </Stack>
  );
};
